import { createTranslationRef } from '@backstage/core-plugin-api/alpha';
import enMessages from './translations/en.json';

export const spikeSearchModalTranslationRef = createTranslationRef({
  id: 'plugin.spike-search-modal',
  messages: enMessages,
});
